import React, { useMemo } from 'react';

import { useIntl } from 'react-intl-next';

import { Field } from '@atlaskit/form';
import { AutoComplete, type AutoCompleteItem, getTeams } from '@atlassian/eoc-auto-complete';
import { useResponderNames } from '@atlassian/eoc-responder-names';

import { FieldResetter } from '../../styled';

import messages from './messages';
import { SelectControl } from './select-control';
import { type Props } from './types';

export const TeamInput = ({ teamId }: Props) => {
	const { formatMessage } = useIntl();

	const [responderTeam] = useResponderNames(teamId ? [{ type: 'team', id: teamId }] : []);

	const defaultValue = useMemo(() => {
		if (responderTeam && 'name' in responderTeam) {
			return {
				...responderTeam,
				label: responderTeam.name,
				value: responderTeam.id,
			};
		}
	}, [responderTeam]);

	return (
		<FieldResetter>
			<Field<AutoCompleteItem | null>
				name="team"
				label={formatMessage(messages.label)}
				defaultValue={defaultValue}
			>
				{({ fieldProps }) => (
					<AutoComplete
						{...fieldProps}
						endpoints={[getTeams]}
						components={{
							DropdownIndicator: () => <></>,
							Control: SelectControl,
						}}
						placeholder={formatMessage(messages.placeholder)}
						isLoading={responderTeam?.isLoading}
						isClearable
					/>
				)}
			</Field>
		</FieldResetter>
	);
};
